<template>
    <el-dialog title="需求须知" :visible.sync="noticeVisible" id="requireNotice"  :close-on-click-modal="false" width="800px">
        <div class="testingInstructions" v-if="dataForm.type == 1">
            1.确认细节下单后，一般是3-5个工作日给初稿。加急需要收取相应的加急费用：
            <br/> a) 2-3个工作日，费用增加订单金额50%；
            <br/> b) 1-2个工作日，费用增加订单金额100%。
            <br/> 2.数据提供：一般输出原图图片格式+PSD文件，其他工程文件格式不可；
            <br/> 3.绘图前的细节确认是保证绘图质量的最重要环节，需耐心沟通。请老师/同学尽量提供详细的内容及参考图。若最终的图需要老师、同学等其它人共同确定，请务必和相关人员沟通清楚。
            <br/> 3.1、初稿调整原则：
            <br/> a) 主体模型提供三次修改机会；
            <br/> b) 小修（细节、文字、颜色等）无限次修改，直至满意；
            <br/> c) 半年之内都可以提供小修服务。
            <br/> 3.2、若初稿模型不满意有以下处理方式：
            <br/> a) 初稿退单或再免费修改一次模型不满意。如果退单，根据工作量协商退款，不提供图片；
            <br/> b) 模型修改三版及以上不满意，不退单，不退款，可协商提供作图内容中的单图。
            <br/> 4、我们按付款先后顺序安排绘图，为保证效率，请在沟通确认细节和报价后24小时下单付款，否则视为取消订单，重新排单接图，时间向后推迟。
            <br/> 5、预约单设计方案请务必让导师/老板知悉，一旦提交，即视为委托方学生与导师的意见达成统一。如果由于委托方师生意见不统一造成的设计延期和修改超版数，责任由委托方承担。
        </div>
        <div class="testingInstructions" v-if="dataForm.type == 2">
            1、下单请下载预约单填写相应信息，并附对应初稿文章内容；
            <br/> 2、如对初稿修改结果不满意，可以免费再次修改；
            <br/> 3、投稿版本，如对我方修改结果有修改，请与我方确认，以确保投稿版本是否有问题；
            <br/> 4、修改部分10%以内内容可以免费检查修改，超过部分需要单独收取费用；
            <br/> 5、修改结果老师会给出相应批注，请作者务必认真查阅确认修改；
            <br/> 6、做哪个项目只选哪个对应的选项即可，请勿勾选未做项目选项。
        </div>
    </el-dialog>
</template>

<script>
export default {
    props: {
        dataForm: {
            type: [Object, Array],
            default: () => {}
        }
    },
    data() {
        return {
            noticeVisible: true,
        }
    }
}
</script>
<style>
#requireNotice .el-dialog__body {
    border-top: 1px solid #eee;
}
</style>
<style scoped>
.testingInstructions {
    line-height: 30px;
}
</style>